export enum WorkPeriodExceptionIds {
  OVERLAPPING_WORK_PERIODS = "OVERLAPPING_WORK_PERIODS",
  MULTIPLE_ONGOING_WORK_PERIODS = "MULTIPLE_ONGOING_WORK_PERIODS",
  NON_CHRONOLOGICAL_TIMES = "NON_CHRONOLOGICAL_TIMES",
  ACTIVITY_OUT_OF_WORK_PERIOD = "ACTIVITY_OUT_OF_WORK_PERIOD",
  INSTRUCTION_FEEDBACK_ACTIVITY_OUT_OF_WORK_PERIOD = "INSTRUCTION_FEEDBACK_ACTIVITY_OUT_OF_WORK_PERIOD",
  CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_ACTIVITIES = "CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_ACTIVITIES",
  CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_FEEDBACK_ACTIVITIES = "CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_FEEDBACK_ACTIVITIES",
  EMPTY_QUANTITIES = "EMPTY_QUANTITIES",
  WORK_PERIOD_EXCEEDS_MAX_DURATION = "WORK_PERIOD_EXCEEDS_MAX_DURATION",
  WORK_PERIOD_DOES_NOT_ACCEPT_CHANGES = "WORK_PERIOD_DOES_NOT_ACCEPT_CHANGES"
}
